export const PERMISSION_RESOURCE_CODES = {
  performance: 'performance',
  businessTrips: 'business-trips',
  approvals: 'approvals',
  collaborationCalendar: 'collaboration-calendar',
  collaborationFollowUps: 'collaboration-follow-ups',
  collaborationTasks: 'collaboration-tasks',
  collaborationAttachments: 'collaboration-attachments',
  marketingCampaigns: 'marketing-campaigns',
  marketingCampaignDetail: 'marketing-campaign-detail',
  marketingCampaignMembers: 'marketing-campaign-members',
  marketingCampaignAnalysis: 'marketing-campaign-analysis',
  leadsMy: 'leads-my',
  leadsTeam: 'leads-team',
  leadsCollab: 'leads-collab',
  leadsPool: 'leads-pool',
  leadsAll: 'leads-all',
  leadsImported: 'leads-imported',
  leadImportConflicts: 'lead-import-conflicts',
  customersMy: 'customers-my',
  customersTeam: 'customers-team',
  customersCollab: 'customers-collab',
  customersPool: 'customers-pool',
  customersAll: 'customers-all',
  contactsMy: 'contacts-my',
  contactsTeam: 'contacts-team',
  contactsCollab: 'contacts-collab',
  contactsAll: 'contacts-all',
  opportunitiesMy: 'opportunities-my',
  opportunitiesFollowed: 'opportunities-followed',
  opportunitiesTeam: 'opportunities-team',
  opportunitiesCollab: 'opportunities-collab',
  opportunitiesPool: 'opportunities-pool',
  opportunitiesAll: 'opportunities-all',
  quotesMy: 'quotes-my',
  quotesTeam: 'quotes-team',
  quotesCollab: 'quotes-collab',
  quotesAll: 'quotes-all',
  contractsMy: 'contracts-my',
  contractsTeam: 'contracts-team',
  contractsCollab: 'contracts-collab',
  contractsAll: 'contracts-all',
  contractsProjectionRepair: 'contracts-projection-repair',
  receiptsList: 'receipts-list',
  receiptsSchedules: 'receipts-schedules',
  receiptsScheduleDetail: 'receipts-schedule-detail',
  invoices: 'invoices',
  analyticsLeadSource: 'analytics-lead-source',
  analyticsBusinessMap: 'analytics-business-map',
  analyticsGovernance: 'analytics-governance',
  settingsTaxonomies: 'settings-taxonomies',
  settingsAutomationRules: 'settings-automation-rules',
  settingsPermissions: 'settings-permissions',
  settingsWorkflowApproval: 'settings-workflow-approval',
  settingsInvoiceProfile: 'settings-invoice-profile',
  settingsAiModelBinding: 'settings-ai-model-binding',
  settingsDictionaries: 'settings-dictionaries',
  settingsDictionaryItems: 'settings-dictionary-items',
  settingsLeadPool: 'settings-lead-pool',
  settingsLeadAssignRules: 'settings-lead-assign-rules',
  settingsIndustries: 'settings-industries',
  settingsAreas: 'settings-areas',
  settingsCustomerPool: 'settings-customer-pool',
  settingsCustomerLimits: 'settings-customer-limits',
  settingsSourceChannels: 'settings-source-channels',
  settingsCustomerLevels: 'settings-customer-levels',
  settingsOpportunityPipelines: 'settings-opportunity-pipelines',
  settingsOpportunityStages: 'settings-opportunity-stages',
  settingsMarketingCampaignTypes: 'settings-marketing-campaign-types',
  settingsMarketingTouchpointTypes: 'settings-marketing-touchpoint-types',
  settingsContractConfig: 'settings-contract-config',
  settingsContractCodeRules: 'settings-contract-code-rules',
} as const;

export const PERMISSION_ACTION_CODES = {
  performance: {
    viewSelf: 'view-self',
    viewTeam: 'view-team',
    viewAll: 'view-all',
    manageTargets: 'manage-targets',
    publishTargets: 'publish-targets',
    submitAdjustment: 'submit-adjustment',
    reviewAdjustment: 'review-adjustment',
    lock: 'lock',
    export: 'export',
    feedback: 'feedback',
  },
  businessTrips: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    manageMembers: 'manage-members',
    manageCloseReasons: 'manage-close-reasons',
    complete: 'complete',
  },
  collaborationCalendar: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
  },
  collaborationFollowUps: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
  },
  collaborationTasks: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
  },
  collaborationAttachments: {
    upload: 'upload',
    delete: 'delete',
  },
  marketingCampaigns: {
    create: 'create',
    edit: 'edit',
  },
  marketingCampaignDetail: {
    edit: 'edit',
  },
  marketingCampaignMembers: {
    manage: 'manage',
  },
  leadsMy: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    putToPool: 'put-to-pool',
    transform: 'transform',
    rescore: 'rescore',
    updateStatus: 'update-status',
  },
  leadsTeam: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    putToPool: 'put-to-pool',
    transform: 'transform',
    rescore: 'rescore',
    updateStatus: 'update-status',
  },
  leadsCollab: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    putToPool: 'put-to-pool',
    transform: 'transform',
    rescore: 'rescore',
    updateStatus: 'update-status',
  },
  leadsPool: {
    claim: 'claim',
    assign: 'assign',
    putToPool: 'put-to-pool',
    transform: 'transform',
    delete: 'delete',
    rescore: 'rescore',
    updateStatus: 'update-status',
  },
  leadsAll: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    transform: 'transform',
    rescore: 'rescore',
    updateStatus: 'update-status',
  },
  leadsImported: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    transform: 'transform',
    rescore: 'rescore',
    updateStatus: 'update-status',
  },
  leadImportConflicts: {
    manage: 'manage',
  },
  customersMy: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    restore: 'restore',
    putToPool: 'put-to-pool',
    updateStatus: 'update-status',
  },
  customersTeam: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    restore: 'restore',
    putToPool: 'put-to-pool',
    updateStatus: 'update-status',
  },
  customersCollab: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    restore: 'restore',
    putToPool: 'put-to-pool',
    updateStatus: 'update-status',
  },
  customersPool: {
    claim: 'claim',
    assign: 'assign',
  },
  customersAll: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    restore: 'restore',
    updateStatus: 'update-status',
  },
  contactsMy: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    enable: 'enable',
    disable: 'disable',
  },
  contactsTeam: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    enable: 'enable',
    disable: 'disable',
  },
  contactsCollab: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    enable: 'enable',
    disable: 'disable',
  },
  contactsAll: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    enable: 'enable',
    disable: 'disable',
  },
  opportunitiesMy: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    putToPool: 'put-to-pool',
  },
  opportunitiesFollowed: {},
  opportunitiesTeam: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    putToPool: 'put-to-pool',
  },
  opportunitiesCollab: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    putToPool: 'put-to-pool',
  },
  opportunitiesPool: {
    claim: 'claim',
    assign: 'assign',
    edit: 'edit',
    delete: 'delete',
  },
  opportunitiesAll: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
  },
  quotesMy: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    submit: 'submit',
    withdraw: 'withdraw',
    compareVersion: 'compare-version',
  },
  quotesTeam: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    submit: 'submit',
    withdraw: 'withdraw',
    compareVersion: 'compare-version',
  },
  quotesCollab: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    submit: 'submit',
    withdraw: 'withdraw',
    compareVersion: 'compare-version',
  },
  quotesAll: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    submit: 'submit',
    withdraw: 'withdraw',
    compareVersion: 'compare-version',
  },
  contractsMy: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    submit: 'submit',
    withdraw: 'withdraw',
  },
  contractsTeam: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    submit: 'submit',
    withdraw: 'withdraw',
  },
  contractsCollab: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    submit: 'submit',
    withdraw: 'withdraw',
  },
  contractsAll: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    submit: 'submit',
    withdraw: 'withdraw',
  },
  contractsProjectionRepair: {
    repair: 'repair',
  },
  receiptsList: {
    viewSelf: 'view-self',
    viewTeam: 'view-team',
    viewAll: 'view-all',
    create: 'create',
    viewVoucher: 'view-voucher',
    sync: 'sync',
    edit: 'edit',
    delete: 'delete',
    submit: 'submit',
    withdraw: 'withdraw',
    syncApproval: 'sync-approval',
  },
  receiptsSchedules: {
    viewSelf: 'view-self',
    viewTeam: 'view-team',
    viewAll: 'view-all',
    enable: 'enable',
    cancel: 'cancel',
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    createReceipt: 'create-receipt',
  },
  receiptsScheduleDetail: {
    createReceipt: 'create-receipt',
    edit: 'edit',
  },
  invoices: {
    create: 'create',
    detail: 'detail',
    edit: 'edit',
    delete: 'delete',
    submit: 'submit',
    withdraw: 'withdraw',
  },
  settingsTaxonomies: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    enable: 'enable',
    disable: 'disable',
  },
  settingsAutomationRules: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    enable: 'enable',
    disable: 'disable',
  },
  settingsPermissions: {
    manage: 'manage',
  },
  settingsWorkflowApproval: {
    manage: 'manage',
    edit: 'edit',
    delete: 'delete',
    enable: 'enable',
    disable: 'disable',
  },
  settingsInvoiceProfile: {
    edit: 'edit',
  },
  settingsAiModelBinding: {
    edit: 'edit',
  },
  settingsDictionaries: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
  },
  settingsDictionaryItems: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
  },
  settingsLeadPool: {
    manage: 'manage',
    edit: 'edit',
  },
  settingsLeadAssignRules: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
    enable: 'enable',
    disable: 'disable',
  },
  settingsIndustries: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
  },
  settingsAreas: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
  },
  settingsCustomerPool: {
    manage: 'manage',
    edit: 'edit',
  },
  settingsCustomerLimits: {
    manage: 'manage',
    edit: 'edit',
  },
  settingsSourceChannels: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
  },
  settingsCustomerLevels: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
  },
  settingsOpportunityPipelines: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
  },
  settingsOpportunityStages: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
  },
  settingsMarketingCampaignTypes: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
  },
  settingsMarketingTouchpointTypes: {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
  },
  settingsContractConfig: {
    manage: 'manage',
    edit: 'edit',
  },
  settingsContractCodeRules: {
    manage: 'manage',
    edit: 'edit',
  },
} as const;
